import { map } from "guinho-automapper-js/index";
import mapping  from "../../mappers/companyOptions/edit/jsonapi-company-options-map";

const convertToViewModel = (data) => {
  const viewModel = map(data, {}, mapping);

  return viewModel;
};

export { convertToViewModel };